import {DisplayOption} from '@/components/interfaces/ComponentOptions';

export enum Channel {
    SPORTS = 'Sports',
    SPORTS_PLUS = 'Sports PLUS',
    BEK_STREAM = 'BEK Stream'
}

export const channelOptions: DisplayOption[] = [
    { id: Channel.SPORTS, name: Channel.SPORTS },
    { id: Channel.SPORTS_PLUS, name: Channel.SPORTS_PLUS },
    { id: Channel.BEK_STREAM, name: Channel.BEK_STREAM }
];

export const sportsChannelOptions: DisplayOption[] = [
    { id: Channel.SPORTS, name: Channel.SPORTS },
    { id: Channel.SPORTS_PLUS, name: Channel.SPORTS_PLUS },
];

export enum Dma {
    EAST = 'East',
    WEST = 'West',
    STATEWIDE = 'Statewide'
}

export const DmaOptions: DisplayOption[] = [
    { id: Dma.EAST, name: Dma.EAST },
    { id: Dma.WEST, name: Dma.WEST },
    { id: Dma.STATEWIDE, name: Dma.STATEWIDE }
];

export enum EventType {
    LIVE = 'live',
    REPLAY = 'replay',
    LIVE_NEWS = 'live-news',
    REPLAY_NEWS = 'replay-news',
    OTHER = 'other',
    GENERIC = 'generic'
}
export const eventTypeOptions: DisplayOption[] = [
    { id: EventType.LIVE, name: 'Live' },
    { id: EventType.REPLAY, name: 'Replay' },
    { id: EventType.LIVE_NEWS, name: 'Live News' },
    { id: EventType.REPLAY_NEWS, name: 'Replay News' },
    { id: EventType.OTHER, name: 'Other' },
];

export interface EventSearchResults {
    count: number;
    events: EventSummary[];
    start: number;
    end: number;
}

export interface EventSummary {
    id: number;
    category: string;
    subcategory: string;
    awayTeam: string;
    awayTeamScore: number;
    homeTeam: string;
    homeTeamScore: number;
    startDateTime: string;
    endDateTime: string;
    gender: number;
    abbreviation: string;
    description: string;
    specialNotes: string;
    title: string;
    dma: string;
    channels: string[];
    staff: string;
    instructions: string;
    status?: number;
    eventType: EventType;
    isStreaming: boolean;
}

export interface Sponsor {
    name: string;
    points: string;
}

export enum BillboardSentStatus {
    SENT = 'SENT',
    NOT_SENT = 'NOT_SENT'
}

export interface Event extends EventSummary {
    location: string;
    filename: string;
    sponsors: Sponsor[];
    includeInDvdLibrary: boolean;
    dvdPrice: string;
    isArchived: boolean;
    billboardCityIds: number[];
    daysBeforeEventToPromote: number[];
    billboardSentStatus: BillboardSentStatus;
}

export interface BillboardCities extends DisplayOption {
    dma: string;
}

export enum BillboardType {
    BILLBOARD_1856_576= 'billboard1856x576',
    BILLBOARD_1920_494 = 'billboard1920x494'
}
